export default "/assets/website/images/play.svg?9df2e9dfdd7e04de996aeab5ea76a8cc";